import React from "react";
import * as styles from "../block/block.module.scss";
import PanelNormal from "../../atoms/box/panel-normal";
import BlockTitle from "../../atoms/typography/block-title";

/**
 * @type {Object} 「UI:atoms - ブロック 著者カード コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {String} title 著者カードのタイトルを受け取るための引数です。
 * @param {Object} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 * 
 */

const AuthorProfile = ({ title, children }) => {
  return (
    <div className={`${styles.authorProfile}`}>
      <PanelNormal>
        <header>
          <BlockTitle text={title} />
        </header>
        <div className={`${styles.content}`}>{children}</div>
      </PanelNormal>
    </div>
  );
};

export default AuthorProfile;
